import createSvgIcon from '../Utils/CreateSvgIcon';

export const StarFilled = createSvgIcon(
  <path d="M480-292.46 309.77-189.69q-6.46 3.46-13.15 3.15-6.7-.31-12.16-4.15-5.46-3.85-8.19-10.12-2.73-6.27-.73-13.96l44.77-193.54L170.54-539q-6.08-5.08-7.58-11.65-1.5-6.58.31-12.85t7.08-10.42q5.27-4.16 12.96-4.77l198.15-17.46 77.08-183.08q3.23-6.69 9.11-10.23Q473.54-793 480-793t12.35 3.54q5.88 3.54 9.11 10.23l77.08 183.08 198.15 17.46q7.69.61 12.96 4.77 5.27 4.15 7.08 10.42 1.81 6.27.31 12.85-1.5 6.57-7.58 11.65L639.69-408.31l45.15 193.54q1.62 7.69-1.11 13.96-2.73 6.27-8.19 10.12-5.46 3.84-12.16 4.15-6.69.31-13.15-3.15L480-292.46Z" />,
  'StarFilled',
  '162 -806 636 636',
);
